import React, { useRef, useEffect } from 'react';
import { View, Animated, Easing } from 'react-native';
import svgIcons from '../../assets';
import { Icon } from '../index';
import { isMobile, isWeb } from '../../utils/responsive';
import { cln } from '../../utils/classnames';

interface Props {
  isScreen?: boolean;
}

const AnimatedBirthdayLogo: React.FC<Props> = ({ isScreen }) => {
  const upY = useRef(new Animated.Value(50)).current;
  const opacity = useRef(new Animated.Value(0)).current;
  useEffect(() => {
    const slowMiddle = Easing.bezier(0.0, 0.55, 0.55, 0.0);
    const slowMiddleWeb = Easing.bezier(0.0, 0.81, 0.81, 0.0);

    Animated.loop(
      Animated.sequence([
        // Reset position & opacity
        Animated.timing(upY, {
          toValue: isMobile && !isScreen ? 40 : 70,
          duration: 0,
          useNativeDriver: !isWeb,
        }),
        Animated.timing(opacity, {
          toValue: 0,
          duration: 0,
          useNativeDriver: !isWeb,
        }),

        // Wait while hidden
        Animated.delay(500),

        // Fade in while moving up
        Animated.parallel([
          Animated.timing(opacity, {
            toValue: 1,
            duration: 200,
            delay: 400,
            easing: Easing.linear,
            useNativeDriver: !isWeb,
          }),
          Animated.timing(upY, {
            toValue: isMobile && !isScreen ? -90 : -100,
            duration: 2000,
            easing: isMobile && !isScreen ? slowMiddle : slowMiddleWeb,
            useNativeDriver: !isWeb,
          }),
        ]),

        // Fade out & reset
        Animated.timing(opacity, {
          toValue: 0,
          duration: 100,
          useNativeDriver: !isWeb,
        }),
        Animated.timing(upY, {
          toValue: isMobile && !isScreen ? 40 : 70,
          duration: 0,
          useNativeDriver: !isWeb,
        }),

        // Optional wait before next loop
        Animated.delay(100),
      ]),
    ).start();
  }, []);

  return (
    <View className="mb-[2px] xs:mb-[4px]">
      <View className="relative">
        <Icon
          icon={svgIcons.logoNoO}
          webSize={{ width: 118, height: 28 }}
          mobileSize={{ width: isScreen ? 118 : 90, height: isScreen ? 28 : 21 }}
        />
        {/*  MOME O */}
        <Animated.View
          style={{ opacity }}
          className={cln(
            ' border-[4px] rounded-full border-[#000] dark:border-[#fff] absolute',
            isScreen
              ? 'w-[26.5px] h-[26.5px] border-[5.25px] left-[30.5px] top-[1px]'
              : 'w-[20px] h-[20px] xs:w-[26.5px] xs:h-[26.5px] xs:border-[5.25px] left-[23.25px] xs:left-[30.5px] top-[0.5px] xs:top-[1px]',
          )}
        />
      </View>
      <Animated.View
        style={{
          transform: [{ translateY: upY }],
        }}
        className={cln('absolute', isScreen ? 'left-[30.5px]' : 'left-[23.25px] xs:left-[30.5px]')}
      >
        <Icon
          icon={svgIcons.ballonIcon}
          webSize={{ width: 27, height: 55 }}
          mobileSize={{ width: isScreen ? 27 : 21, height: isScreen ? 55 : 42 }}
        />
      </Animated.View>
    </View>
  );
};

export default AnimatedBirthdayLogo;
